import { FormControl, FormGroup } from '@angular/forms';
import { IDeviceType } from '@internal-models/device-type.model';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup } from '@shared-libs/interfaces';

export class DeviceTypeFormFactory {
	public static create(eventType?: IDeviceType): IFormGroup<IDeviceType> {
		return new FormGroup({
			name: new FormControl(eventType?.name, [SharedFormValidators.required, SharedFormValidators.strictString]),
			description: new FormControl(eventType?.description),
		}) as IFormGroup;
	}
}
